var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8679875_logout_circle_line_icon 1",
    clipPath: "url(#clip0_4822_9375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9167 28.416H33.5833V33.5827H12.9167V41.3327L0 30.9994L12.9167 20.666V28.416ZM10.3333 46.4994H17.329C20.3119 49.1301 23.9906 50.8442 27.9236 51.436C31.8566 52.0278 35.8767 51.4721 39.5018 49.8357C43.1268 48.1993 46.2026 45.5517 48.3602 42.2105C50.5177 38.8694 51.6654 34.9766 51.6654 30.9994C51.6654 27.0221 50.5177 23.1293 48.3602 19.7882C46.2026 16.447 43.1268 13.7994 39.5018 12.163C35.8767 10.5266 31.8566 9.97095 27.9236 10.5628C23.9906 11.1546 20.3119 12.8687 17.329 15.4994H10.3333C12.7375 12.2887 15.8574 9.68301 19.4449 7.88922C23.0325 6.09544 26.989 5.16301 31 5.16602C45.2677 5.16602 56.8333 16.7316 56.8333 30.9994C56.8333 45.2671 45.2677 56.8327 31 56.8327C26.989 56.8357 23.0325 55.9033 19.4449 54.1095C15.8574 52.3157 12.7375 49.71 10.3333 46.4994Z",
    fill: "#FC000F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4822_9375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.419ad7aeb6a6304242aa9fa90bab7859.svg";
export { ForwardRef as ReactComponent };